import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabase';

import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';

// Uvozimo unutrašnji sadržaj
import HomeInventoryContent from './components/HomeInventoryContent';

const InventarioPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [adminData, setAdminData] = useState({
    nome: '',
    ruolo: ''
  });

  useEffect(() => {
    fetchAdminData();
  }, [t]);

  
  const fetchAdminData = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (user) {
        const { data: profilo, error: profError } = await supabase
          .from('profili')
          .select('nome, cognome, ruolo')
          .eq('id', user.id)
          .single();

        if (profilo && !profError) {
          setAdminData({
            nome: `${profilo.nome} ${profilo.cognome}`,
            ruolo: profilo.ruolo
          });
        }
      }
    } catch (err) {
      console.error("Greška pri učitavanju podataka:", err.message);
    }
  };

  const handleLogout = () => navigate('/landing-authentication');
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={toggleSidebar} />
      <DashboardHeader onLogout={handleLogout} userName={adminData.nome || 'Admin'} />

      <main className="main-content with-sidebar">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
          
          {/* Unutrašnji sadržaj inventara */}
          <HomeInventoryContent />

          <div className="mt-12 opacity-50">
             {/* Ovdje kasnije mogu ići dodatni grafikoni */}
          </div>
          
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default InventarioPage;